export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13492.8da4f97d.jpg";